import CheckSample from '@/api/services/check-sample'

const state = {
    sample: {},
    selectedSampleId: 0
}

const getters = {
    sample(state) {
        return state.sample
    },

    selectedSampleId(state) {
        return state.selectedSampleId
    }
}

const mutations = {
    setSample(state, sample) {
        state.sample = sample
    },

    setSelectedSampleId(state, sampleId) {
        state.selectedSampleId = sampleId
    },
    
    setIsDone(state, isDone) {
        state.sample = Object.assign({
            isDone: isDone
        }, state.sample)
    }
}

const actions = {
    checkSample({ commit }, payload) {
        return CheckSample()
            .postCustomerData(payload)
            .then(data => {
                console.log(data)

                if (data.data) {
                    commit('setSample', data.data)
                }
            })
    },

    setSelectedSampleId({ commit }, sampleId) {
        commit('setSelectedSampleId', sampleId)
    },

    setSample({ commit }, sample) {
        commit('setSample', sample)
    },

    clearSample({ commit }) {
        commit('setSelectedSampleId', 0)
        commit('setSample', {})
    },

    setSampleIsDone({ commit }) {
        commit('setIsDone', true)
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}